<template>
  <div class="accruals_row">
    <span class="accruals_game" :class="'accruals_game__' + accrual.game">
      <span class="accruals_game_name">{{ formattedGameName }}</span>
    </span>
    <span class="accruals_title" v-html="accrual.title" />
    <span class="accruals_date">{{ accrualDate | dateFormat }}</span>
    <span class="accruals_description" v-html="accrual.description" />
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { GAME_NAMES_SHORT } from '@/constants'

@Component
class AccrualsHistoryItem extends Vue {
  @Prop({ type: Object, required: true }) accrual

  get accrualDate () {
    const { accruedAt, updatedAt } = this.accrual

    return accruedAt || updatedAt
  }

  get formattedGameName () {
    return GAME_NAMES_SHORT[this.accrual.game]
  }
}

export default AccrualsHistoryItem
</script>

<style scoped>

</style>
